var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagBorder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_519_15409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.69474 12.3334L12.3474 7.68008M3.15207 10.7581C2.12207 9.72741 1.60674 9.21275 1.41541 8.54408C1.22341 7.87542 1.38741 7.16542 1.71541 5.74608L1.90407 4.92742C2.17941 3.73275 2.31741 3.13542 2.72607 2.72608C3.13474 2.31675 3.73274 2.17942 4.92741 1.90408L5.74607 1.71475C7.16607 1.38742 7.87541 1.22342 8.54407 1.41475C9.21274 1.60675 9.72741 2.12208 10.7574 3.15208L11.9774 4.37208C13.7714 6.16542 14.6667 7.06142 14.6667 8.17475C14.6667 9.28875 13.7707 10.1847 11.9781 11.9774C10.1847 13.7707 9.28874 14.6667 8.17474 14.6667C7.06141 14.6667 6.16474 13.7707 4.37207 11.9781L3.15207 10.7581ZM6.68088 4.97661C7.20158 5.49731 7.20158 6.34153 6.68088 6.86223C6.16018 7.38292 5.31596 7.38292 4.79526 6.86223C4.27457 6.34153 4.27457 5.49731 4.79526 4.97661C5.31596 4.45591 6.16018 4.45591 6.68088 4.97661Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_519_15409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagBorder);
export default __webpack_public_path__ + "static/media/tagBorder.157b4a39a96681166cbf065a2c016f8f.svg";
export { ForwardRef as ReactComponent };